import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const AdvisorOverviewPage = lazy(() => import("@/features/dashboard/pages/advisor-overview"));

export const Route = createFileRoute("/(app)/dashboard/advisor/overview")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground p-6 text-sm">Loading clients overview...</div>}>
      <AdvisorOverviewPage />
    </Suspense>
  ),
});
